export default {
    debug: true,
    cookies: {
        WIDGET_TIP_COOKIE: 'tipClosed',
        WIDGET_DEBUG_COOKIE: 'widgetDebug',
        WIDGET_QUESTIONNAIRE: 'Chat_rozpoczecie_rozmowy',
        WIDGET_START_CHAT_COOKIE: 'Chat_rozpoczecie_rozmowy',
        WIDGET_START_QUESTIONNAIRE_COOKIE: 'Chat_rozpoczecie_ankiety',
        USABILA_COOKIE: 'campaign_closed',
        WIDGET_QUESTIONNAIRE_LAST: 'widgetQuestionnaireLast',
        WIDGET_QUESTIONNAIRE_COUNTER: 'widgetQuestionnaireCounter',
        WIDGET_PROACTIVE: 'proactiveWidget'
    },
    chatOptions: {
        questionnaireMinimumTime: 120,
        questionnaireMinimumTimeMax: 90,
        textEditMaxLines: 4,
        registration: {
            api: {
                mojorange: 'fVz66WRMinXmCtue89oz'
            },
            args: ['FirstName', 'userIdentificationNumber', 'category'],
            mapping: {
                userIdentificationNumber: 'userInCaseNumber'
            }
        }
    },
    rwd: {
        smallBreakpoint: 300,
        mediumBreakpoint: 767
    }
};
